angular.module('cfn').service('harvestBookingService', harvestBookingService);

harvestBookingService.$inject = [
  '$log',
  '$http',
  'timeZoneHackService'
];

function harvestBookingService($log, $http, timeZoneHackService) {

  const HARVESTBOOKINGDATA_SERVICE_URL = '/365FarmNet/mod/booking-service/booking/operation/rest/v1.0/harvestbookingdata/';

  let getSysCultureForField = function (fieldId, date) {
    let queryData = {
      eventDate: timeZoneHackService.toBackendTimezone(date),
      fieldIds: [fieldId]
    };
    return $http.post(HARVESTBOOKINGDATA_SERVICE_URL, queryData).then(
      (response) => {
        if(response.data) {
          return response.data;
        } else {
          return [];
        }
      },
      (errorResponse) => {
        return [];
      }
    );
  };

  let getSysCulturesForFields = function (fieldIds, date) {
    let queryData = {
      eventDate: timeZoneHackService.toBackendTimezone(date),
      fieldIds: fieldIds
    };
    return $http.post(HARVESTBOOKINGDATA_SERVICE_URL, queryData).then(
      (response) => {
        if(response.data) {
          return response.data;
        } else {
          return [];
        }
      },
      (errorResponse) => {
        return [];
      }
    );
  };


  // Public
  let harvestBookingService = {
    getSysCultureForField: getSysCultureForField,
    getSysCulturesForFields: getSysCulturesForFields
  };

  return harvestBookingService;
}
